export const AUTH_LOGIN = 'AUTH/LOGIN';
export const GENERATE_TWO_FACTOR = 'AUTH/GENERATE_TWO_FACTOR';
export const VALIDATE_TWO_FACTOR = 'AUTH/VALIDATE_TWO_FACTOR';
export const AUTH_LOGOUT = 'AUTH/LOGOUT';
export const RETRIEVE_ME = 'ME/RETRIEVE_ME';
export const FORGOT_PASSWORD = 'AUTH/FORGOT_PASSWORD';
export const CODE_VALIDATION = 'AUTH/CODE_VALIDATION';
export const NEW_PASSWORD = 'AUTH/NEW_PASSWORD';
